import { Link } from 'Components/Core';
import { hasNonEmptyValue } from 'Lib/Any';
import React from 'react';
import { FormatTypes } from '../../../../../Lib/Format';
import { Field, TextOutput } from '../../../../Core';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../types';

interface IImportedTestDetails extends IWorksheetComponent {
  importedTest: any;
}

const ImportedTestDetailsSection: React.FC<IImportedTestDetails> = ({ importedTest }) => {
  const importedFromWorkOrder = hasNonEmptyValue(importedTest?.WorkOrder);
  return (
    <ListFieldSection wide heading={importedTest?.Type?.Caption}>
      <FieldSet>
        <Field
          label={importedFromWorkOrder ? 'Work Order ID' : 'Sample ID'}
          input={<TextOutput />}
          value={importedFromWorkOrder ? importedTest.WorkOrder?.WorkOrderId : importedTest.Sample?.SampleId}
          horizontal
        />
        <Field
          label="Date Sampled"
          input={<TextOutput />}
          value={importedTest.Sample?.DateTimeSampled}
          format={{ type: FormatTypes.Date }}
          horizontal
          visible={!importedFromWorkOrder}
        />
        <Field
          label="Date Tested"
          input={<TextOutput />}
          value={importedTest.Results?.TestedDate}
          format={{ type: FormatTypes.Date }}
          horizontal
        />
        <div>
          <Link to={`/worksheets/${importedTest.WorksheetId}`}>Open Worksheet</Link>
        </div>
      </FieldSet>
    </ListFieldSection>
  );
};

export { ImportedTestDetailsSection };
export default ImportedTestDetailsSection;
